/**
 * Authentication Service
 * 
 * Handles authorization checks — verifies the authenticated user
 * has been pre-created by an admin in Cognito.
 */

import apiClient from './api';

/**
 * Check if user email is authorized (pre-created by admin in Cognito).
 * 
 * @param {string} email - User email to check
 * @returns {Promise<{authorized: boolean, email?: string, name?: string, role?: string}>}
 */
export const checkUserAuthorization = async () => {
  try {
    const response = await apiClient.get('/users/check-auth');
    const data = response.data?.data || response.data;
    return {
      authorized: true,
      email: data.email,
      name: data.name,
      role: data.role
    };
  } catch (error) {
    if (error.response?.status === 403) {
      return { authorized: false };
    }
    console.error('Authorization check failed:', error);
    // On network/server error, deny access to be safe
    return { authorized: false };
  }
};
